export const generativeAiListBrandGuidelines = "/generative_ai/list_brand_guidelines";
